import { NNBSP } from './constants';
import { getSymbol } from './symbols';

export const getValueWithCurrency = (
  value: string | number,
  currency: string,
) => {
  //TODO: which currencies are before sum
  if (currency === 'USD') {
    return `${currency ? getSymbol(currency) : ''}${NNBSP}${value || '0'}`;
  }
  return `${value || '0'}${NNBSP}${currency ? getSymbol(currency) : ''}`;
};
